var hasClass = function hasClass(node, className) {
    return !!node && (' ' + node.className + ' ').indexOf(' ' + className + ' ') !== -1;
};

function addClass(node, className) {
    if (node && !hasClass(node, className)) {
        if (node.className !== '') {
            node.className += ' ';
        }

        node.className += className.trim();
    }
}

function removeClass(node, className) {
    while (hasClass(node, className)) {
        node.className = (' ' + node.className + ' ').replace(' ' + className + ' ', ' ').trim();
    }
}

function toggleClass(node, className, forceTo) {
    var has = hasClass(node, className);

    if (has !== forceTo) {
        if (!has) {
            addClass(node, className);
        } else {
            removeClass(node, className);
        }
    }
}

export { hasClass, addClass, removeClass, toggleClass };
